import $ from 'jquery';
import 'slick-carousel';

export default function TestimonialSlider() {
  const $slider = $('.js-testimonial-slider');
  if (!$slider.length) return;

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: $('.nav .slick-prev'),
    nextArrow: $('.nav .slick-next'),
    adaptiveHeight: true,
    infinite: true,
  });
}
